angular.module('vastdesk').
  component('bridAudioPlayer',  {
    bindings: {
      playerId: '@',
      audioUrl: '@'
    },
    template: '<div class="audio-player" id="{{$bridAudioPlayerCtrl.playerId}}"></div>',
    controllerAs: '$bridAudioPlayerCtrl',
    controller: ['$rootScope', '$element', function($rootScope, $element) {

      var self = this;

      var initPlayer = function() {
        var playerConfig = {
          "id": 8272,
          "playerId": 20206,
          "height": "150",
          "mobile_height": "100",
          "Skin": {
            "id": 1
          },
          "video": {
            "source": {
              "src": self.audioUrl
            }
          }
        };

        Brid.forceConfigLoad = true;

        $bp(self.playerId, playerConfig, function(){
          this.volume(0.2);
        });
      };

      $rootScope.$on('bridAudioChange', function(e, args) {
        if (args.playerId === self.playerId) {
          self.audioUrl = args.audioUrl;

          $bp(self.playerId).destroy();

          $element.append('<div class="audio-player" id="' + self.playerId + '"></div>');

          setTimeout(function() {
            initPlayer();
          }, 0);
        }
      });

      this.$onInit = function() {
        setTimeout(function() {
          initPlayer();

          $('a[data-toggle="tab"][href="#tabSettings"]').on('shown.bs.tab', function (e) {
            $bp(self.playerId).onResizeFunc();
          });
        }, 0);
      };

    }]
});
